// extracted by mini-css-extract-plugin
export default {"badge":"VisibilityCallback_badge__73ir-","left":"VisibilityCallback_left__oHF46"};